<template>
  <div>
    <video v-if="!loadedState" @ended="introFunc" muted autoplay playsinline>
      <source src="../assets/video/intro-v4.mp4" type="video/mp4" />
    </video>
    <img
      v-else
      class="map"
      :class="[
        { 'map-center-me': activeName === 'Me' },
        { 'map-center-sam': activeName === 'Sam Morris' },
        { 'map-center-erica': activeName === 'Erica Morris' },
      ]"
      src="../assets/detroit.png"
      alt="detroit"
    />
    <div class="interface" :class="{ on: showInterface }">
      <img
        src="../assets/icons/JL-pin.png"
        alt="JL Icon"
        class="jl-icon"
        :class="[
          { 'center-jl': activeName === 'Sam Morris' },
          { remove: activeName !== 'Sam Morris' && activeName !== '' },
        ]"
        @click="
          togglePinDetail( 'Sam Morris', '1201 S. Main St <br /> Ann Arbor, MI 48104 <br />')
        "
      />
      <img
        src="../assets/icons/FL-pin.png"
        alt="FL Icon"
        class="fl-icon"
        :class="[
          { 'center-fl': activeName === 'Me' },
          { remove: activeName !== 'Me' && activeName !== '' },
        ]"
        @click="
          togglePinDetail('Me', '1 Hart Plaza <br /> Detroit, MI 48226 <br />')
        "
      />
      <img
        src="../assets/icons/SL-pin.png"
        alt="SL Icon"
        class="sl-icon"
        :class="[
          { 'center-sl': activeName === 'Erica Morris' },
          { remove: activeName !== 'Erica Morris' && activeName !== '' },
        ]"
        @click="
          togglePinDetail(
            'Erica Morris',
            '2648 W Grand Blvd <br /> Detroit, MI 48208 <br />'
          )
        "
      />
      <img src="../assets/icons/menu/menu.png" alt="SL Icon" class="menu" @click="toggleMenu" />
      <Callbar
        :onstar="toggleOnstar"
        :toggleSos="toggleSosDialog"
        :toggleRoadside="toggleRoadside"
      />
    </div>
    <div :class="{ active: menu }">
      <Menu :close="toggleMenu" />
    </div>
    <div :class="{ active: onstarMenu }">
      <OnstarOptions :close="toggleOnstar" />
    </div>
    <div :class="{ active: pinDetail }">
      <PinDetail :name="activeName" :close="togglePinDetail" :address="activeAddress" />
    </div>
    <div :class="{ active: pinDetail }">
      <PinDetail :name="activeName" :close="togglePinDetail" :address="activeAddress" />
    </div>
    <div :class="{ active: sosDialog }">
      <AlertSOS
        :toggle="toggleSosDialog"
        title="SOS"
        message="For life-threatening situations call 911. For other urgent situations call OnStar Emergency."
      />
    </div>
    <div :class="{ active: roadsideDialog }">
      <AlertRoadside
        :toggle="toggleRoadside"
        title="Roadside "
        message="Are you sure you want to call for Roadside Assistance?"
      />
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Callbar from "@/components/Callbar.vue";
import OnstarOptions from "@/components/OnstarOptions.vue";
import PinDetail from "@/components/PinDetail.vue";
import AlertSOS from "./AlertSOS";
import AlertRoadside from "./AlertRoadside";

export default {
  name: "HomeScreen",
  components: {
    Menu,
    OnstarOptions,
    Callbar,
    PinDetail,
    AlertSOS,
    AlertRoadside
  },
  data() {
    return {
      menu: false,
      onstarMenu: false,
      pinDetail: false,
      activeName: "",
      activeAddress: "",
      showInterface: false,
      roadsideDialog: false,
      sosDialog: false
    };
  },
  mounted() {
    if (this.loadedState) {
      this.showInterface = true;
    }
  },
  methods: {
    toggleMenu() {
      this.menu = !this.menu;
    },
    toggleOnstar() {
      this.onstarMenu = !this.onstarMenu;
    },
    togglePinDetail(name, address) {
      this.pinDetail = !this.pinDetail;

      if (this.pinDetail) {
        this.activeName = name;
        this.activeAddress = address;
      } else {
        setTimeout(() => {
          this.activeName = "";
        }, 300);
      }
    },
    lock() {
      this.$router.push("/lock");
    },
    toggleSosDialog() {
      this.sosDialog = !this.sosDialog;
    },
    toggleRoadside() {
      this.roadsideDialog = !this.roadsideDialog;
    },
    introFunc() {
      if (!this.loadedState) {
        this.$store.commit("toggle");
        this.showInterface = !this.showInterface;
      }
    }
  },
  computed: {
    loadedState() {
      return this.$store.state.loaded;
    }
  }
};
</script>

<style lang="scss" scoped>
.menuOn {
  background-color: rgba(0, 0, 0, 0.5);
}
video {
  position: absolute;
  top: -1.5%;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}
.map {
  position: absolute;
  top: -1.5%;
  left: -120%;
  height: 100%;
  object-fit: cover;
  transition: all 300ms ease-out;
  z-index: 0;
}
.map-center-me {
  left: -148%;
}
.map-center-erica {
  left: -141%;
}
.map-center-sam {
  left: -96%;
}
.interface {
  opacity: 0;
  transition: all 100ms ease-in-out;
}
.interface.on {
  opacity: 1;
}
.jl-icon {
  position: absolute;
  top: 41%;
  right: 68%;
  width: 14%;
  height: auto;
  transition: all 300ms ease-in-out;
}
.sl-icon {
  position: absolute;
  top: 35%;
  right: 24%;
  width: 14%;
  height: auto;
  transition: all 300ms ease-in-out;
}
.fl-icon {
  position: absolute;
  top: 39%;
  right: 15%;
  width: 15%;
  height: auto;
  transition: all 300ms ease-in-out;
}
.jl-icon:hover {
  cursor: pointer;
}
.sl-icon:hover {
  cursor: pointer;
}
.fl-icon:hover {
  cursor: pointer;
}
.center-fl {
  right: 44%;
}
.center-sl {
  right: 44%;
}
.center-jl {
  right: 44%;
}
.remove {
  display: none;
}
.menu {
  position: absolute;
  top: 8%;
  left: 8%;
  width: 15%;
  height: auto;
}
.menu:hover {
  cursor: pointer;
  opacity: 0.7;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.active {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
